// import { ServiceDescription, ServicesFilter } from "../components/services";

// const ServicesTwo = () => {
//   return (
//     <div className="pt-20 max-w-7xl mx-auto px-4">
//       <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
//         <div className="md:col-span-3">
//           <ServiceDescription />
//         </div>
//         <div className="md:col-span-1">
//           <ServicesFilter />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServicesTwo;


import React, { useState } from "react";
import { ServiceDescription, ServicesFilter } from "../components/swimming-pool";

const SwimmingPool = () => {
  const [selectedService, setSelectedService] = useState("Competition Pool");

  const handleFilterChange = (service) => {
    setSelectedService(service);
  };

  return (
    <div className="pt-20 max-w-7xl mx-auto px-4">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
        <div className="md:col-span-3">
          <ServiceDescription service={selectedService} />
        </div>
        <div className="md:col-span-1">
        <ServicesFilter
  onFilterChange={handleFilterChange}
  activeFilter={selectedService}
/>

        </div>
      </div>
    </div>
  );
};

export default SwimmingPool;


// const ServiceDescription = ({ service }) => {
//   const serviceData = {
//     "Property Management": "We offer end-to-end property management solutions tailored to your needs.",
//     "Manage Services": "Our service management solutions ensure smooth and efficient operations.",
//     "Consulting Services": "Expert consulting services to guide your projects to success.",
//     "Home Buying": "Assisting you in finding and purchasing your dream home.",
//     "Home Selling": "Helping you sell your property quickly and efficiently.",
//   };

//   return (
//     <div>
//       <h1 className="heading">{service}</h1>
//       <p className="mt-3">{serviceData[service]}</p>
//     </div>
//   );
// };
